<template>
    <div class="ckeditor" :class="[{'validate-error':!validateResult},options.type]">
        <div v-if="readonly" class="ckeditor-readOnly" :style="{height: height + 'px'}">
            <scroll>
                <div v-html="value"></div>
            </scroll>
        </div>
        <div v-else class="container">
            <iframe src="/static/gikam/plugin/ckeditor/index.html"></iframe>
        </div>
    </div>
</template>
<script>
export default {
    props: ["options", "propValue", "rowIndex"],

    data() {
        return {
            validateResult: true,
            readonly: this.options.readonly,
            field: this.options.field,
            value: this.propValue,
            height: this.options.height
        };
    },

    watch: {
        value(val) {
            let value;
            if (this.options.type == "script") {
                value = val.replace(/<\/?p[^>]*>/gi,'');
            } else {
                value = val;
            }
            this.$emit("change", this.options.field, value, this.rowIndex);
        },

        propValue(value) {
            this.value = value;
        }
    },

    mounted() {
        this.initEditor();
    },

    methods: {
        initEditor() {
            let iframe = this.$el.querySelector("iframe");
            iframe.onload = function () {
                //加载完毕初始化编辑页面
                let options = {
                    type:
                        this.options.type === "ckeditor"
                            ? "Ckeditor"
                            : "ScriptEditor",
                    options: this
                };
                iframe.contentWindow.init(options);
            }.bind(this);
        }
    }
};
</script>

<style scoped>
.ckeditor {
    height: 100%;
    width: 100%;
}

.ckeditor .ckeditor-readOnly {
    height: 200px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-family: Microsoft YaHei, serif;
    font-size: 12px;
}

.ckeditor > .container {
    border-radius: 4px;
}

.ckeditor.script > .container {
    height: 30px;
}

.ckeditor > .container {
    height: 350px;
}

.ckeditor > .container > iframe {
    border: none;
    width: 100%;
    height: 100%;
}
</style>